/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Environment, YouTube, YouTubeVideoInfo} from 'compob2b-libs';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class YoutubeVideoService {
  private uri = 'https://www.youtube1.com/oembed';

  private options = {
    headers: new HttpHeaders({
      Accept: 'text/html',
      'Content-Type': 'application/xhtml+xml',
      'X-IGNORE-TOKEN': 'yes',
      'ngsw-bypass': 1
    }),
    params: {
      url: '',
      format: 'json',
    }
  };

  constructor(
    private readonly http: HttpClient,
    @Inject('environment') private readonly environment: Environment
  ) {
  }

  getYouTubeVideoInfo(url: string): Observable<YouTubeVideoInfo> {
    this.options.params.url = url;

    return this.http.get<YouTubeVideoInfo>(String(this.uri), this.options)
      .pipe(
        catchError(err => {
          console.error('Произошла ошибка:', err);
          return of({title: url} as YouTubeVideoInfo);
        })
      );
  }

  getSrc(video: YouTube): string {
    return this.environment.youTubeShortLink + video.code + '/default.jpg';
  }

}
